import { swiperDefaults } from '../globals.js'
import Swiper from 'swiper'
import { A11y, Navigation, Pagination } from 'swiper/modules';

/**
 * Product LookBook Slider
 */
new Swiper('[data-lookbook-gallery]', {
    ...swiperDefaults,
    centeredSlides: true,
    slidesPerView: 1,
    loop: true,
    modules: [Pagination, Navigation, A11y]
})